//
export default [
    'pch_provider_account',
	'pch_purchase_invoices',
	'pch_purchase_orders',
	'pch_provider_account_banks.g_bank',
	'pch_provider_accounts',
	//'pch_purchase_quotations',
	'pch_provider_branch_offices',
]